import * as React from 'react';
import { cn } from '@/lib/utils';

const GuideTimeline = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-timeline',
      // Estilos base
      'relative w-full max-w-full pb-8',
      // Estilos para telas grandes (xl)
      'xl:ml-32',
      className
    )}
  >
    {/* Linha */}
    <div
      aria-hidden="true"
      className={cn('absolute bottom-0 left-1/2 top-0 z-0 -translate-x-1/2', 'w-0 border-l-2 border-dashed border-neutral-light')}
    />
    {/* Bolinha */}
    <div
      aria-hidden="true"
      className={cn('absolute left-1/2 z-0 h-3 w-3 rounded-full bg-neutral-light', 'top-0 -translate-x-1/2 -translate-y-1/2')}
    />
    {/* Bolinha */}
    <div
      aria-hidden="true"
      className={cn('absolute left-1/2 z-0 h-3 w-3 rounded-full bg-neutral-light', 'bottom-0 -translate-x-1/2 translate-y-1/2')}
    />
    <ul className="flex list-none flex-col gap-[52px]">{props.children}</ul>
  </div>
));
GuideTimeline.displayName = 'GuideTimeline';

const GuideTimelineDay = React.forwardRef(({ className, isPause, ...props }, ref) => (
  <li
    ref={ref}
    className={cn(
      'c-guide-timeline-day',
      // Estilos base
      'z-10 flex flex-col gap-5',
      // Variante isPause
      isPause && 'gap-0 bg-neutral-bright [&_.c-guide-timeline-title]:text-xl [&_.c-guide-timeline-title]:font-bold [&_.c-guide-timeline-title]:text-primary-dark',
      className
    )}
    {...props}
  />
));
GuideTimelineDay.displayName = 'GuideTimelineDay';

const GuideTimelineHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-timeline-header',
      // Estilos base
      'flex items-center gap-x-3',
      'scroll-mt-[164px]',
      className
    )}
    {...props}
  />
));
GuideTimelineHeader.displayName = 'GuideTimelineHeader';

const GuideTimelineFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-timeline-footer',
      // Estilos base
      'flex items-center gap-x-3',
      className
    )}
    {...props}
  />
));
GuideTimelineFooter.displayName = 'GuideTimelineFooter';

const GuideTimelineIcon = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-guide-timeline-icon',
      // Estilos base
      'h-8 w-8 shrink-0',
      className
    )}
    {...props}
  />
));
GuideTimelineIcon.displayName = 'GuideTimelineIcon';

const GuideTimelineTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h2
    ref={ref}
    className={cn(
      'c-guide-timeline-title',
      // Estilos base
      'mb-0 text-xs font-light',
      'text-neutral-darker',
      className
    )}
    {...props}
  />
));
GuideTimelineTitle.displayName = 'GuideTimelineTitle';

const GuideTimelineDate = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-timeline-date',
      // Estilos base
      'mb-0 text-xs font-light',
      'ml-auto shrink-0 text-neutral',
      className
    )}
    {...props}
  />
));
GuideTimelineDate.displayName = 'GuideTimelineDate';

const GuideTimelineCards = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-timeline-cards',
      // Estilos base
      'flex flex-col gap-3',
      className
    )}
    {...props}
  />
));
GuideTimelineCards.displayName = 'GuideTimelineCards';

const GuideTimelineBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-timeline-body',
      // Estilos base
      'flex flex-wrap items-center justify-center gap-3 p-5 text-center',
      className
    )}
    {...props}
  />
));
GuideTimelineBody.displayName = 'GuideTimelineBody';

const GuideTimelineContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-guide-timeline-content',
      // Estilos base
      '',
      className
    )}
    {...props}
  />
));
GuideTimelineContent.displayName = 'GuideTimelineContent';

const GuideTimelineText = React.forwardRef(({ className, ...props }, ref) => (
  <p
    ref={ref}
    className={cn(
      'c-guide-timeline-text',
      // Estilos base
      'mb-0 text-xs font-light text-neutral-darker',
      className
    )}
    {...props}
  />
));
GuideTimelineText.displayName = 'GuideTimelineText';

const GuideTimelineImg = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-guide-timeline-img',
      // Estilos base
      'h-[72px] w-[96px]',
      className
    )}
    {...props}
  />
));
GuideTimelineImg.displayName = 'GuideTimelineImg';

export { GuideTimeline, GuideTimelineDay, GuideTimelineHeader, GuideTimelineFooter, GuideTimelineIcon, GuideTimelineTitle, GuideTimelineDate, GuideTimelineCards, GuideTimelineBody, GuideTimelineContent, GuideTimelineText, GuideTimelineImg };
